export function toggleSitemap() {
  if (window.matchMedia('(max-width: 767px)').matches) {
    const triggers = document.querySelectorAll('.js-first-link');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.target.classList.toggle('is-active');
        e.target.nextElementSibling.classList.toggle('is-active');
      });
    });
  }
}
